import { Story } from '../../DocTypes';

export const dataDrivenItemStylesStory: Story = {
  title: 'Data driven item styles',
  description: 'List with item styles driven by data',
  coreComponent: {
    html: `<tag-list
    primary-field='name'
    secondary-field='description'
    item-container-style-field='style'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        name: 'Jordan Norry',
        disableEdit: true,
        description: 'Should be crossed out',
        style: '{"text-decoration": "line-through"}'
      },
      {
        name: 'Sarah Young',
        disableEdit: false,
        description: 'Should NOT be crossed out',
        style: '{"text-decoration": "none"}'
      },
      {
        name: 'Susan Warmly',
        disableEdit: true,
        description: 'Should be crossed out',
        style: '{"text-decoration": "line-through"}'
      }
    ]);
  });
  `,
  },
  reactWrapper: {
    jsx: `<TagList
    primaryField='name'
    secondaryField='description'
    itemContainerStyleField='style'
    data={[
      {
        name: 'Jordan Norry',
        disableEdit: true,
        description: 'Should be crossed out',
        style: '{"text-decoration": "line-through"}'
      },
      {
        name: 'Sarah Young',
        disableEdit: false,
        description: 'Should NOT be crossed out',
        style: '{"text-decoration": "none"}'
      },
      {
        name: 'Susan Warmly',
        disableEdit: true,
        description: 'Should be crossed out',
        style: '{"text-decoration": "line-through"}'
      }
    ]}
  />`,
  },
};
